<template>
    <el-container class="Wrapper">
        <el-container class="container">
            <div class="shangs">
                <div class="comms">
                    <div class="fenss">
                        <el-form :model="searchForm">
                            <el-input v-model="searchForm.name" placeholder="请输入菜品名称" @keyup.enter="siftsea"></el-input>
                            <el-button type="primary" @click="siftsea">查找</el-button>
                            <el-button type="primary" @click="openAddDialog">添加菜品</el-button>
                            <el-button type="primary" @click="openGenerateMenuDialog"
                                :disabled="selectedDishes.length === 0">生成菜单</el-button>
                            <!-- 添加删除勾选菜品按钮 -->
                            <el-button type="danger" @click="deleteSelectedDishes"
                                :disabled="selectedDishes.length === 0">删除勾选菜品</el-button>
                        </el-form>
                    </div>
                    
                    <div class="dishesbody">
                        <el-table v-loading="loading" element-loading-text="加载中，请稍后..."
                            style="width: 100%; margin-left: 10%;" height="85%" :data="management" class="orders"
                            @selection-change="handleSelectionChange" ref="tableRef">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column label="序号" width="30">
                                <template v-slot="{ $index }">
                                    {{ $index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="dishName" label="名称" width="170" show-overflow-tooltip />
                            <el-table-column prop="dishCategory" label="类别" width="70">
                            </el-table-column>
                            <el-table-column fixed="right" label="修改" width="250">
                                <template #default="scope">
                                    <el-button type="danger" @click="open(scope.row.id)">删除菜品</el-button>
                                    <el-button type="primary" @click="openEditDialog(scope.row.id)">编辑菜品</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="dishesfoots">
                        <div class="demo-pagination-blocks">
                            <el-pagination v-model:current-page="currentPage4" v-model:page-size="pageSize4"
                                @size-change="handleSizeChangese" @current-change="handleCurrentChangese"
                                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper" :total="tatol">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <!-- 添加/编辑商品弹窗 -->
                <el-dialog v-model="addDialogVisible" title="添加/编辑菜品" :width="dialogWidth" :top="dialogTop"
                    :style="{ position: 'absolute', left: dialogLeft + 'px', top: dialogTop + 'px' }"
                    @mousedown="startDrag" @mousemove="handleDrag" @mouseup="endDrag">
                    <el-form v-model="newDish">
                        <el-form-item label="菜品名称">
                            <el-input v-model="newDish.dishName"></el-input>
                        </el-form-item>
                        <el-form-item label="菜品类别">
                            <el-input v-model="newDish.dishCategory"></el-input>
                        </el-form-item>
                        <el-form-item label="菜谱食材">
                            <el-table :data="newDish.detailList" stripe @row-click="handleRowClick"
                                :row-style="rowStyle" @selection-change="handleIngredientSelectionChange">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column label="食材名称" prop="foodIngredients">
                                    <template #default="scope">
                                        <el-autocomplete v-model="scope.row.foodIngredients"
                                            :fetch-suggestions="querySearchAsync" placeholder="请输入食材名称"
                                            @select="handleSelect(scope.$index, $event)" :value-key="'foodName'">
                                            <template #item="scope">
                                                <div>{{ scope.item.foodName }}</div>
                                            </template>
                                        </el-autocomplete>
                                    </template>
                                </el-table-column>
                                <el-table-column label="食材克数" prop="grammage">
                                    <template #default="scope">
                                        <el-input v-model.number="scope.row.grammage" type="number"
                                            @input="calculateNutrition(scope.$index)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="食材分量" prop="portion">
                                    <template #default="scope">
                                        <el-select v-model="scope.row.portion"
                                            @change="handlePortionChange(scope.$index)">
                                            <el-option label="大份" value="大份"></el-option>
                                            <el-option label="中份" value="中份"></el-option>
                                            <el-option label="小份" value="小份"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="营养成分">
                                    <template #default="scope">
                                        <span>碳水: {{ nutritionList[scope.$index].cho.toFixed(2) }}g</span>
                                        <span>能量: {{ nutritionList[scope.$index].energy.toFixed(2) }}kcal</span>
                                        <span>脂肪: {{ nutritionList[scope.$index].fat.toFixed(2) }}g</span>
                                        <span>钠: {{ nutritionList[scope.$index].na.toFixed(2) }}mg</span>
                                        <span>蛋白质: {{ nutritionList[scope.$index].protein.toFixed(2) }}g</span>
                                    </template>
                                </el-table-column>
                            </el-table>

                        </el-form-item>
                        <el-form-item label="大份营养成分">
                            <div>
                                <span>碳水: {{ newDish.bigIngredients.cho.toFixed(2) }}g</span>
                                <span>能量: {{ newDish.bigIngredients.energy.toFixed(2) }}kcal</span>
                                <span>脂肪: {{ newDish.bigIngredients.fat.toFixed(2) }}g</span>
                                <span>钠: {{ newDish.bigIngredients.na.toFixed(2) }}mg</span>
                                <span>蛋白质: {{ newDish.bigIngredients.protein.toFixed(2) }}g</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="中份营养成分">
                            <div>
                                <span>碳水: {{ newDish.middleIngredients.cho.toFixed(2) }}g</span>
                                <span>能量: {{ newDish.middleIngredients.energy.toFixed(2) }}kcal</span>
                                <span>脂肪: {{ newDish.middleIngredients.fat.toFixed(2) }}g</span>
                                <span>钠: {{ newDish.middleIngredients.na.toFixed(2) }}mg</span>
                                <span>蛋白质: {{ newDish.middleIngredients.protein.toFixed(2) }}g</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="小份营养成分">
                            <div>
                                <span>碳水: {{ newDish.smallIngredients.cho.toFixed(2) }}g</span>
                                <span>能量: {{ newDish.smallIngredients.energy.toFixed(2) }}kcal</span>
                                <span>脂肪: {{ newDish.smallIngredients.fat.toFixed(2) }}g</span>
                                <span>钠: {{ newDish.smallIngredients.na.toFixed(2) }}mg</span>
                                <span>蛋白质: {{ newDish.smallIngredients.protein.toFixed(2) }}g</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="总营养成分">
                            <div>
                                <span>碳水: {{ totalNutrition.cho.toFixed(2) }}g</span>
                                <span>能量: {{ totalNutrition.energy.toFixed(2) }}kcal</span>
                                <span>脂肪: {{ totalNutrition.fat.toFixed(2) }}g</span>
                                <span>钠: {{ totalNutrition.na.toFixed(2) }}mg</span>
                                <span>蛋白质: {{ totalNutrition.protein.toFixed(2) }}g</span>
                            </div>
                        </el-form-item>
                    </el-form>
                    <template #footer>
                        <el-button type="primary" @click="addIngredientRow">增加行</el-button>
                        <el-button type="danger" @click="removeSelectedIngredients"
                            :disabled="selectedIngredients.length === 0">删除勾选行</el-button>
                        <el-button @click="cancelDialog('add')">取消</el-button>
                        <el-button type="primary" @click="saveDish">确定</el-button>
                    </template>
                </el-dialog>
                <!-- 生成菜单弹窗 -->
                <el-dialog v-model="addMenuDialogVisible" title="添加/编辑菜单" :width="dialogWidth"  :top="dialogTop"
                    :style="{ position: 'absolute', left: menuDialogLeft + 'px', top: menuDialogTop + 'px' }"
                    @mousedown="startMenuDrag" @mousemove="handleMenuDrag" @mouseup="endMenuDrag">
                    <el-form v-model="newMenu">
                        <el-form-item label="套餐名称">
                            <el-input v-model="newMenu.meal"></el-input>
                        </el-form-item>
                        <el-form-item label="菜单日期">
                            <el-select v-model="newMenu.week" placeholder="请选择日期">
                                <el-option v-for="day in weekDays" :key="day" :label="day" :value="day">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="菜品类别">
                            <el-select v-model="newMenu.categoriesId" placeholder="请选择类别">
                                <el-option v-for="category in categories" :key="category.id" :label="category.name"
                                    :value="category.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用餐时间">
                            <el-select v-model="newMenu.time" placeholder="请选择用餐时间">
                                <el-option label="早餐" value="早餐"></el-option>
                                <el-option label="午餐" value="午餐"></el-option>
                                <el-option label="晚餐" value="晚餐"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="菜谱菜品">
                            <el-table :data="newMenu.detailList" stripe @row-click="handleMenuRowClick"
                                :row-style="rowStyle" @selection-change="handleMenuSelectionChange">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column label="菜品名称" prop="dishName">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.dishName" readonly
                                            @click="openChooseDishDialog(scope.$index)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="菜品类别" prop="dishCategory">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.dishCategory"></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form>
                    <template #footer>
                        <el-button type="danger" @click="removeSelectedMenuItems"
                            :disabled="selectedMenuItems.length === 0">删除选中行</el-button>
                        <el-button @click="cancelDialog('menu')">取消</el-button>
                        <el-button type="primary" @click="saveMenu">确定</el-button>
                    </template>
                </el-dialog>
            </div>
        </el-container>
    </el-container>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { toRaw } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import instance from '../network/storester.js';
import { ElMessage, ElMessageBox } from 'element-plus';

const searchForm = ref({
    name: '',
});
const dialogLeft = ref(0);
const dialogTop = ref(100);
const menuDialogLeft = ref(0);
const menuDialogTop = ref(100);

// 新增变量用于记录鼠标按下时的位置
const startX = ref(0);
const startY = ref(0);
const isDragging = ref(false);

const startDrag = (event) => {
    isDragging.value = true;
    startX.value = event.clientX;
    startY.value = event.clientY;
};

const handleDrag = (event) => {
    if (isDragging.value) {
        const offsetX = event.clientX - startX.value;
        const offsetY = event.clientY - startY.value;
        dialogLeft.value += offsetX;
        dialogTop.value += offsetY;
        startX.value = event.clientX;
        startY.value = event.clientY;
    }
};

const endDrag = () => {
    isDragging.value = false;
};

// 菜单弹窗的拖动处理
const startMenuDrag = (event) => {
    isDragging.value = true;
    startX.value = event.clientX;
    startY.value = event.clientY;
};

const handleMenuDrag = (event) => {
    if (isDragging.value) {
        const offsetX = event.clientX - startX.value;
        const offsetY = event.clientY - startY.value;
        menuDialogLeft.value += offsetX;
        menuDialogTop.value += offsetY;
        startX.value = event.clientX;
        startY.value = event.clientY;
    }
};

const endMenuDrag = () => {
    isDragging.value = false;
};
const resultss = ref([])
const querySearchAsync = (queryString, cb) => {
    if (queryString.trim() === '') {
        cb([]);
        return;
    }
    instance.get(`/api/foodIngredientStandards/list?foodName=${queryString}`)
        .then(response => {
            const results = response.data.data;
            resultss.value = response.data.data
            cb(results);
        })
        .catch(error => {
            ElMessage.error('搜索食材失败');
            //console.error('搜索食材失败:', error);
            cb([]);
        });
};
const handleSelect = (rowIndex, selectedItem) => {
    if (!selectedItem || !selectedItem.foodName) {
        ElMessage.error('未获取到选中的食材信息');
        return;
    }
    // 直接使用搜索结果中的营养成分
    const selectedFood = resultss.value.find(item => item.id === selectedItem.id);
    if (selectedFood) {
        newDish.value.detailList[rowIndex] = {
            ...newDish.value.detailList[rowIndex],
            foodIngredients: selectedFood.foodName,
            foodData: selectedFood,
            foodId: selectedFood.id,
            cho: parseFloat(selectedFood.cho || 0),
            energy: parseFloat(selectedFood.energy || 0),
            fat: parseFloat(selectedFood.fat || 0),
            na: parseFloat(selectedFood.na || 0),
            protein: parseFloat(selectedFood.protein || 0),
            // 保存每 100g 营养成分
            choStandard: parseFloat(selectedFood.cho || 0),
            fatStandard: parseFloat(selectedFood.fat || 0),
            energyStandard: parseFloat(selectedFood.energy || 0),
            proteinStandard: parseFloat(selectedFood.protein || 0),
            naStandard: parseFloat(selectedFood.na || 0)
        };
        // 更新 foodNutritionList 数组
        foodNutritionList.value[rowIndex] = {
            cho: parseFloat(selectedFood.cho || 0),
            energy: parseFloat(selectedFood.energy || 0),
            fat: parseFloat(selectedFood.fat || 0),
            na: parseFloat(selectedFood.na || 0),
            protein: parseFloat(selectedFood.protein || 0)
        };
        // 重新计算营养成分
        calculateNutrition(rowIndex);
    }
};

const tatol = ref(0);
const management = ref([]);
const managem = ref(null);
const loading = ref(true);
const router = useRouter();
const manage = localStorage.getItem('permissionsStatus');
const page = reactive({ pageNum: 1, pageSize: 10 });

// 新增/编辑商品弹窗相关
const addDialogVisible = ref(false);
const newDish = ref({
    detailList: [
        {
            dishId: 0,
            foodIngredients: '',
            grammage: 0,
            id: 0,
            isDeleted: 0,
            portion: '',
            powerFactor: 0,
            foodId: 0,
            foodData: null,
            cho: 0,
            fat: 0,
            energy: 0,
            protein: 0,
            na: 0,
            choStandard: 0,
            energyStandard: 0,
            fatStandard: 0,
            naStandard: 0,
            proteinStandard: 0
        }
    ],
    dishCategory: '',
    dishName: '',
    meal:'',
    id: 0,
    isDeleted: 0,
    bigIngredients: {
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    },
    middleIngredients: {
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    },
    smallIngredients: {
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    }
});
const selectedRowIndex = ref(-1);
const dialogWidth = ref('60%'); // 自定义弹窗宽度
// const dialogTop = ref('10vh'); // 自定义弹窗顶部距离
const isEdit = ref(false); // 判断是添加还是编辑

// 生成菜单相关
const addMenuDialogVisible = ref(false);
const newMenu = ref({
    week: '',
    categoriesId: '',
    time: '',
    meal:'',
    detailList: []
});
const selectedDishes = ref([]);
const weekDays = ref(['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']);
const categories = ref([]);
const tableRef = ref(null);
const selectedMenuRowIndex = ref(-1);
const selectedMenuItems = ref([]);

// 新的营养成分数组
const nutritionList = ref([
    {
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    }
]);

// 新增：记录勾选的食材行
const selectedIngredients = ref([]);

// 计算总营养成分
const totalNutrition = computed(() => {
    const total = {
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    };
    nutritionList.value.forEach(item => {
        total.cho += parseFloat(item.cho);
        total.energy += parseFloat(item.energy);
        total.fat += parseFloat(item.fat);
        total.na += parseFloat(item.na);
        total.protein += parseFloat(item.protein);
    });
    total.cho = parseFloat(total.cho.toFixed(2));
    total.energy = parseFloat(total.energy.toFixed(2));
    total.fat = parseFloat(total.fat.toFixed(2));
    total.na = parseFloat(total.na.toFixed(2));
    total.protein = parseFloat(total.protein.toFixed(2));
    return total;
});


const handleSizeChangese = (val) => {
    page.pageSize = val;
    loading.value = true;
    setTimeout(() => {
        siftsea();
    }, 0);
};

// 当前页改变时触发
const handleCurrentChangese = (val) => {
    page.pageNum = val;
    loading.value = true;
    setTimeout(() => {
        siftsea();
    }, 0);
};

const siftsea = () => {
    if (isHandlingResize.value) return;
    isHandlingResize.value = true;
    instance.get(`/api/dish/list?dishName=${searchForm.value.name}&pageNum=${page.pageNum}&pageSize=${page.pageSize}`)
        .then(response => {
            setTimeout(() => {
                managem.value = response.data.data.dataList;
                management.value = toRaw(managem.value);
                tatol.value = response.data.data.total;
                loading.value = false;
                if (tableRef.value) {
                    management.value.forEach(row => {
                        if (selectedDishes.value.some(dish => dish.id === row.id)) {
                            tableRef.value.toggleRowSelection(row, true);
                        }
                    });
                }
                isHandlingResize.value = false;
            }, 0);
        })
        .catch(error => {
            //console.log(error);
            ElMessage({
                showClose: true,
                message: '请登录',
                type: 'error',
            });
            router.push('./');
            isHandlingResize.value = false;
        });
};

const openAddDialog = () => {
    if (isHandlingResize.value) return;
    isHandlingResize.value = true;
    setTimeout(() => {
        addDialogVisible.value = true;
        selectedRowIndex.value = -1;
        isEdit.value = false;
        newDish.value = {
            detailList: [
                {
                    dishId: 0,
                    foodIngredients: '',
                    grammage: 0,
                    id: 0,
                    isDeleted: 0,
                    portion: '',
                    powerFactor: 0,
                    foodId: 0,
                    foodData: null,
                    cho: 0,
                    fat: 0,
                    energy: 0,
                    protein: 0,
                    na: 0,
                    choStandard: 0,
                    energyStandard: 0,
                    fatStandard: 0,
                    naStandard: 0,
                    proteinStandard: 0
                }
            ],
            dishCategory: '',
            dishName: '',
            meal:'',
            id: 0,
            isDeleted: 0,
            bigIngredients: {
                cho: 0,
                energy: 0,
                fat: 0,
                na: 0,
                protein: 0
            },
            middleIngredients: {
                cho: 0,
                energy: 0,
                fat: 0,
                na: 0,
                protein: 0
            },
            smallIngredients: {
                cho: 0,
                energy: 0,
                fat: 0,
                na: 0,
                protein: 0
            }
        };
        nutritionList.value = [
            {
                cho: 0,
                energy: 0,
                fat: 0,
                na: 0,
                protein: 0
            }
        ];
        selectedIngredients.value = [];
        isHandlingResize.value = false;
    }, 0);
};

const bigIngredients = ref('')
const middleIngredients = ref('')
const smallIngredients = ref('')
const foodNutritionList = ref([])
const openEditDialog = (id) => {
    if (isHandlingResize.value) return;
    isHandlingResize.value = true;

    instance.get(`/api/dish/${id}`)
        .then(response => {
            setTimeout(() => {
                addDialogVisible.value = true;
                selectedRowIndex.value = -1;
                isEdit.value = true;
                newDish.value = response.data.data;
                //console.log(newDish.value)
                try {
                    bigIngredients.value = newDish.value.bigIngredients ? JSON.parse(newDish.value.bigIngredients) : { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
                    middleIngredients.value = newDish.value.middleIngredients ? JSON.parse(newDish.value.middleIngredients) : { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
                    smallIngredients.value = newDish.value.smallIngredients ? JSON.parse(newDish.value.smallIngredients) : { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };

                    // 确保大份、中份、小份营养成分数据为数字类型
                    newDish.value.bigIngredients = {
                        cho: parseFloat(bigIngredients.value.cho),
                        energy: parseFloat(bigIngredients.value.energy),
                        fat: parseFloat(bigIngredients.value.fat),
                        na: parseFloat(bigIngredients.value.na),
                        protein: parseFloat(bigIngredients.value.protein)
                    };
                    newDish.value.middleIngredients = {
                        cho: parseFloat(middleIngredients.value.cho),
                        energy: parseFloat(middleIngredients.value.energy),
                        fat: parseFloat(middleIngredients.value.fat),
                        na: parseFloat(middleIngredients.value.na),
                        protein: parseFloat(middleIngredients.value.protein)
                    };
                    newDish.value.smallIngredients = {
                        cho: parseFloat(smallIngredients.value.cho),
                        energy: parseFloat(smallIngredients.value.energy),
                        fat: parseFloat(smallIngredients.value.fat),
                        na: parseFloat(smallIngredients.value.na),
                        protein: parseFloat(smallIngredients.value.protein)
                    };
                } catch (error) {
                    //console.error('JSON 解析错误:', error);
                    ElMessage({
                        type: 'error',
                        message: '解析菜品营养成分数据失败，请稍后重试',
                    });
                }

                // 初始化营养成分数组
                nutritionList.value = newDish.value.detailList.map((row) => {
                    const cho = parseFloat(row.cho || 0);
                    const energy = parseFloat(row.energy || 0);
                    const fat = parseFloat(row.fat || 0);
                    const na = parseFloat(row.na || 0);
                    const protein = parseFloat(row.protein || 0);
                    return {
                        cho,
                        energy,
                        fat,
                        na,
                        protein
                    };
                });
                //console.log(newDish.value.detailList)

                foodNutritionList.value = newDish.value.detailList.map((row) => {
                    const cho = parseFloat(row.choStandard || 0);
                    const energy = parseFloat(row.energyStandard || 0);
                    const fat = parseFloat(row.fatStandard || 0);
                    const na = parseFloat(row.naStandard || 0);
                    const protein = parseFloat(row.proteinStandard || 0);

                    return {
                        cho,
                        energy,
                        fat,
                        na,
                        protein
                    };
                });
                //console.log(foodNutritionList.value)
                // 计算总营养成分
                const total = {
                    cho: 0,
                    energy: 0,
                    fat: 0,
                    na: 0,
                    protein: 0
                };
                nutritionList.value.forEach(item => {
                    total.cho += parseFloat(item.cho);
                    total.energy += parseFloat(item.energy);
                    total.fat += parseFloat(item.fat);
                    total.na += parseFloat(item.na);
                    total.protein += parseFloat(item.protein);
                });
                totalNutrition.value = {
                    cho: parseFloat(total.cho.toFixed(2)),
                    energy: parseFloat(total.energy.toFixed(2)),
                    fat: parseFloat(total.fat.toFixed(2)),
                    na: parseFloat(total.na.toFixed(2)),
                    protein: parseFloat(total.protein.toFixed(2))
                };

                selectedIngredients.value = [];

                isHandlingResize.value = false;
            }, 0);
        })
        .catch(error => {
            ElMessage({
                type: 'error',
                message: '获取菜品信息失败，请稍后重试',
            });
            isHandlingResize.value = false;
        });
};


const open = (id) => {
    ElMessageBox.confirm(
        '您确定要删除该商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            instance.get(`/api/dish/deleted/${id}`)
                .then(response => {
                    loading.value = true;
                    ElMessage({
                        type: 'success',
                        message: '删除成功',
                    });
                    siftsea();
                })
                .catch((error) => {
                    //console.log(error);
                });
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '取消删除',
            });
        });
};

const isHandlingResize = ref(false);

const saveDish = () => {
    // 手动校验菜品名称和类别
    if (!newDish.value.dishName.trim()) {
        ElMessage({
            type: 'error',
            message: '菜品名称为必填项'
        });
        return;
    }
    if (!newDish.value.dishCategory.trim()) {
        ElMessage({
            type: 'error',
            message: '菜品类别为必填项'
        });
        return;
    }

    // 检查食材部分的校验
    for (const row of newDish.value.detailList) {
        const hasValue = row.foodIngredients.trim() || row.grammage || row.portion.trim();
        if (hasValue) {
            if (!row.foodIngredients.trim()) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则食材名称必须填写'
                });
                return;
            }
            if (!row.grammage) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则食材克数必须填写'
                });
                return;
            }
            if (!row.portion.trim()) {
                ElMessage({
                    type: 'error',
                    message: '若某一行中有一个字段不为空，则食材分量必须填写'
                });
                return;
            }
        }
    }

    // 确保 detailList 中不为空的项才添加到数组
    const validDetailList = newDish.value.detailList.filter(item => item.foodIngredients.trim() !== '');
    newDish.value.detailList = validDetailList;

    const dishToSave = {
        bigIngredients: JSON.stringify(newDish.value.bigIngredients),
        detailList: newDish.value.detailList.map(item => {
            const { foodData, ...rest } = item;
            const index = newDish.value.detailList.indexOf(item);
            return {
                ...rest,
                cho: nutritionList.value[index].cho,
                energy: nutritionList.value[index].energy,
                fat: nutritionList.value[index].fat,
                na: nutritionList.value[index].na,
                protein: nutritionList.value[index].protein,
                // 保存每 100g 营养成分
                choStandard: item.choStandard,
                fatStandard: item.fatStandard,
                energyStandard: item.energyStandard,
                proteinStandard: item.proteinStandard,
                naStandard: item.naStandard
            };
        }),
        dishCategory: newDish.value.dishCategory,
        dishName: newDish.value.dishName,
        id: newDish.value.id,
        isDeleted: 0,
        middleIngredients: JSON.stringify(newDish.value.middleIngredients),
        smallIngredients: JSON.stringify(newDish.value.smallIngredients)
    };

    const apiUrl = '/api/dish/save';
    instance.post(apiUrl, dishToSave)
        .then(response => {
            if (response.data.state === 20000) {
                ElMessage({
                    type: 'success',
                    message: `${isEdit.value ? '编辑' : '新增'}菜品成功`,
                });
                addDialogVisible.value = false;
                siftsea(); // 刷新列表
            } else {
                ElMessage({
                    type: 'error',
                    message: response.data.msg || '添加失败',
                });
            }

        })
        .catch(error => {
            //console.log(`${isEdit.value ? '编辑' : '新增'}菜品失败`, error);
            ElMessage({
                type: 'error',
                message: `${isEdit.value ? '编辑' : '新增'}菜品失败，请稍后重试`,
            });
        });
};

const removeSelectedIngredients = () => {
    if (selectedIngredients.value.length > 0) {
        // 按索引从大到小排序，避免删除元素后索引错乱
        selectedIngredients.value.sort((a, b) => b - a);
        selectedIngredients.value.forEach(index => {
            newDish.value.detailList.splice(index, 1);
            nutritionList.value.splice(index, 1);
        });
        selectedIngredients.value = [];
        handlePortionChange()
    }
};

const handleRowClick = (row, event, column) => {
    const index = newDish.value.detailList.indexOf(row);
    selectedRowIndex.value = index;
};

const handleMenuRowClick = (row, event, column) => {
    const index = newMenu.value.detailList.indexOf(row);
    selectedMenuRowIndex.value = index;
};

const rowStyle = ({ row, rowIndex }) => {
    if (rowIndex === selectedRowIndex.value || rowIndex === selectedMenuRowIndex.value) {
        return { background: '#e5f6ff' };
    }
    return {};
};

const handleSelectionChange = (val) => {
    selectedDishes.value = val;
};

// 新增：处理食材勾选变化
const handleIngredientSelectionChange = (val) => {
    selectedIngredients.value = val.map(row => newDish.value.detailList.indexOf(row));
};

// 新增：处理菜单勾选变化
const handleMenuSelectionChange = (val) => {
    selectedMenuItems.value = val;
};

const openGenerateMenuDialog = () => {
    addMenuDialogVisible.value = true;
    newMenu.value = {
        week: '',
        meal:'',
        categoriesId: '',
        time: '',
        detailList: selectedDishes.value.map(dish => ({
            dishId: dish.id, // 获取 dishId
            dishName: dish.dishName,
            dishCategory: dish.dishCategory
        }))
    };
    // 获取分类数据
    instance.get('/api/categories/getMeanCategories')
        .then(response => {
            categories.value = response.data.data;
        })
        .catch(error => {
            ElMessage({
                type: 'error',
                message: '获取分类数据失败，请稍后重试',
            });
        });
};

// 新增：删除选中的菜单菜品
const removeSelectedMenuItems = () => {
    if (selectedMenuItems.value.length > 0) {
        selectedMenuItems.value.forEach(item => {
            const index = newMenu.value.detailList.findIndex(dish => dish.dishId === item.dishId);
            if (index !== -1) {
                newMenu.value.detailList.splice(index, 1);
                // 删除列表上对应的勾选项
                const dishIndex = selectedDishes.value.findIndex(dish => dish.id === item.dishId);
                if (dishIndex !== -1) {
                    selectedDishes.value.splice(dishIndex, 1);
                }
                // 取消表格中对应行的勾选状态
                if (tableRef.value) {
                    const rowToUnselect = management.value.find(row => row.id === item.dishId);
                    if (rowToUnselect) {
                        tableRef.value.toggleRowSelection(rowToUnselect, false);
                    }
                }
            }
        });
        selectedMenuItems.value = [];
    }
};

const saveMenu = () => {
    // 手动校验菜单日期、菜品类别和用餐时间
    console.log(newMenu.value.meal)
    if (!newMenu.value.week) {
        ElMessage({
            type: 'error',
            message: '菜单日期为必填项'
        });
        return;
    }
      if (!newMenu.value.meal) {
        ElMessage({
            type: 'error',
            message: '套餐为必填项'
        });
        return;
    }
    if (!newMenu.value.categoriesId) {
        ElMessage({
            type: 'error',
            message: '菜品类别为必填项'
        });
        return;
    }
    if (!newMenu.value.time) {
        ElMessage({
            type: 'error',
            message: '用餐时间为必填项'
        });
        return;
    }

    // 生成要保存的菜单数据
    const menuData = newMenu.value.detailList.map(dish => ({
        categoriesId: newMenu.value.categoriesId,
        dishId: dish.dishId, // 使用获取的 dishId
        foodId: dish.foodId,
        dishName: dish.dishName,
        id: 0,
        isDeleted: 0,
        time: newMenu.value.time,
        week: newMenu.value.week,
        setMenu:newMenu.value.meal
    }));

    const apiUrl = '/api/menuManager/saveBatch';
    instance.post(apiUrl, menuData)
        .then(response => {
            if (response.data.state === 20000) {
                ElMessage({
                    type: 'success',
                    message: '生成菜单成功',
                });
                addMenuDialogVisible.value = false;
                // 保存成功后取消表格勾选选项
                selectedDishes.value = [];
                if (tableRef.value) {
                    tableRef.value.clearSelection();
                }
            } else {
                ElMessage({
                    type: 'error',
                    message: response.data.msg || '生成菜单失败',
                });
            }
        })
        .catch(error => {
            //console.log('生成菜单失败', error);
            ElMessage({
                type: 'error',
                message: '生成菜单失败，请稍后重试',
            });
        });
};

const openChooseDishDialog = (index) => {
    // 这里可以实现选择菜品的逻辑，暂时留空
};

const cancelDialog = (type) => {
    if (isHandlingResize.value) return;
    isHandlingResize.value = true;
    setTimeout(() => {
        selectedRowIndex.value = -1;
        selectedMenuRowIndex.value = -1;
        if (type === 'add') {
            addDialogVisible.value = false;
        } else if (type === 'menu') {
            addMenuDialogVisible.value = false;
            selectedDishes.value = [];
            selectedMenuItems.value = [];
            if (tableRef.value) {
                tableRef.value.clearSelection();
            }
        }
        isHandlingResize.value = false;
    }, 0);
};

const addIngredientRow = () => {
    newDish.value.detailList.push({
        dishId: 0,
        foodIngredients: '',
        grammage: 0,
        id: 0,
        isDeleted: 0,
        portion: '',
        powerFactor: 0,
        foodId: 0,
        foodData: null,
        cho: 0,
        fat: 0,
        energy: 0,
        protein: 0,
        na: 0,
    });
    nutritionList.value.push({
        cho: 0,
        energy: 0,
        fat: 0,
        na: 0,
        protein: 0
    });
};
const handlePortionChange = (rowIndex) => {
    // 重置大份、中份、小份的营养成分
    newDish.value.bigIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
    newDish.value.middleIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
    newDish.value.smallIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };

    // 重新计算大份、中份、小份的营养成分
    newDish.value.detailList.forEach((row, index) => {
        const { cho, energy, fat, na, protein } = nutritionList.value[index];
        const choValue = parseFloat(cho);
        const energyValue = parseFloat(energy);
        const fatValue = parseFloat(fat);
        const naValue = parseFloat(na);
        const proteinValue = parseFloat(protein);

        if (row.portion === '大份') {
            newDish.value.bigIngredients.cho += choValue;
            newDish.value.bigIngredients.energy += energyValue;
            newDish.value.bigIngredients.fat += fatValue;
            newDish.value.bigIngredients.na += naValue;
            newDish.value.bigIngredients.protein += proteinValue;
        } else if (row.portion === '中份') {
            newDish.value.middleIngredients.cho += choValue;
            newDish.value.middleIngredients.energy += energyValue;
            newDish.value.middleIngredients.fat += fatValue;
            newDish.value.middleIngredients.na += naValue;
            newDish.value.middleIngredients.protein += proteinValue;
        } else if (row.portion === '小份') {
            newDish.value.smallIngredients.cho += choValue;
            newDish.value.smallIngredients.energy += energyValue;
            newDish.value.smallIngredients.fat += fatValue;
            newDish.value.smallIngredients.na += naValue;
            newDish.value.smallIngredients.protein += proteinValue;
        }
    });
};

const calculateNutrition = (rowIndex) => {
    const row = newDish.value.detailList[rowIndex];
    const foodNutrition = foodNutritionList.value[rowIndex];
    //console.log('进入')
    //console.log(rowIndex)
    //console.log(foodNutritionList.value)
    //console.log(row.grammage)
    if (foodNutrition && row.grammage) {
        const cho = (parseFloat(foodNutrition.cho) * parseFloat(row.grammage) / 100);
        const energy = (parseFloat(foodNutrition.energy) * parseFloat(row.grammage) / 100);
        const fat = (parseFloat(foodNutrition.fat) * parseFloat(row.grammage) / 100);
        const na = (parseFloat(foodNutrition.na) * parseFloat(row.grammage) / 100);
        const protein = (parseFloat(foodNutrition.protein) * parseFloat(row.grammage) / 100);

        nutritionList.value[rowIndex].cho = parseFloat(cho.toFixed(2));
        nutritionList.value[rowIndex].energy = parseFloat(energy.toFixed(2));
        nutritionList.value[rowIndex].fat = parseFloat(fat.toFixed(2));
        nutritionList.value[rowIndex].na = parseFloat(na.toFixed(2));
        nutritionList.value[rowIndex].protein = parseFloat(protein.toFixed(2));

        // 重置大份、中份、小份的营养成分
        newDish.value.bigIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
        newDish.value.middleIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };
        newDish.value.smallIngredients = { cho: 0, energy: 0, fat: 0, na: 0, protein: 0 };

        // 重新计算大份、中份、小份的营养成分
        newDish.value.detailList.forEach((row, index) => {
            const foodNutrition = foodNutritionList.value[index];
            if (foodNutrition && row.grammage) {
                const cho = (parseFloat(foodNutrition.cho) * parseFloat(row.grammage) / 100);
                const energy = (parseFloat(foodNutrition.energy) * parseFloat(row.grammage) / 100);
                const fat = (parseFloat(foodNutrition.fat) * parseFloat(row.grammage) / 100);
                const na = (parseFloat(foodNutrition.na) * parseFloat(row.grammage) / 100);
                const protein = (parseFloat(foodNutrition.protein) * parseFloat(row.grammage) / 100);

                if (row.portion === '大份') {
                    newDish.value.bigIngredients.cho += parseFloat(cho.toFixed(2));
                    newDish.value.bigIngredients.energy += parseFloat(energy.toFixed(2));
                    newDish.value.bigIngredients.fat += parseFloat(fat.toFixed(2));
                    newDish.value.bigIngredients.na += parseFloat(na.toFixed(2));
                    newDish.value.bigIngredients.protein += parseFloat(protein.toFixed(2));
                } else if (row.portion === '中份') {
                    newDish.value.middleIngredients.cho += parseFloat(cho.toFixed(2));
                    newDish.value.middleIngredients.energy += parseFloat(energy.toFixed(2));
                    newDish.value.middleIngredients.fat += parseFloat(fat.toFixed(2));
                    newDish.value.middleIngredients.na += parseFloat(na.toFixed(2));
                    newDish.value.middleIngredients.protein += parseFloat(protein.toFixed(2));
                } else if (row.portion === '小份') {
                    newDish.value.smallIngredients.cho += parseFloat(cho.toFixed(2));
                    newDish.value.smallIngredients.energy += parseFloat(energy.toFixed(2));
                    newDish.value.smallIngredients.fat += parseFloat(fat.toFixed(2));
                    newDish.value.smallIngredients.na += parseFloat(na.toFixed(2));
                    newDish.value.smallIngredients.protein += parseFloat(protein.toFixed(2));
                }
            }
        });
    } else {
        nutritionList.value[rowIndex].cho = 0;
        nutritionList.value[rowIndex].energy = 0;
        nutritionList.value[rowIndex].fat = 0;
        nutritionList.value[rowIndex].na = 0;
        nutritionList.value[rowIndex].protein = 0;
    }
};



// 新增：删除勾选菜品的方法
const deleteSelectedDishes = () => {
    if (selectedDishes.value.length === 0) {
        ElMessage.warning('请先勾选要删除的菜品');
        return;
    }
    ElMessageBox.confirm(
        '您确定要删除勾选的菜品吗？',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        }
    ).then(() => {
        const ids = selectedDishes.value.map(dish => dish.id);
        const deletePromises = ids.map(id => instance.get(`/api/dish/deleted/${id}`));
        Promise.all(deletePromises)
            .then(() => {
                ElMessage.success('删除成功');
                siftsea();
            })
            .catch(error => {
                //console.log('删除失败', error);
                ElMessage.error('删除失败，请稍后重试');
            });
    }).catch(() => {
        ElMessage.info('取消删除');
    });
};

onMounted(() => {
    siftsea();
});
</script>

<style>
.leftnavbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 15vw;
    height: 100vh;
    background-color: #545c64;
}


.container {
    position: fixed;
    top: 0;
    left: 15vw;
}

.container_top {
    width: 85vw;
    height: 10vh;
    background-color: #545c64;
}

.main {
    position: fixed;
    top: 10vh;
    left: 11vw;
    width: 85vw;
    height: 90vh;
}

.orders {
    position: fixed;
    margin-top: 15vh;
    left: 8vw;
}

.fenss .el-select {
    width: 14vw;
    font-size: 12px;
    margin-left: 10px;
}

.comms .el-table {
    position: fixed;
    top: 6%;
    left: 1%;
}

.shangs .el-dialog {
    width: 50%;
}

.comms.el-table tr.el-table__row {
    height: 65px !important;
    font-size: 12px !important;
}

.shangs {
    font-size: 12px !important;
}

.shangs .el-table {
    width: 100%;
}

.shangs.el-table__header-wrapper table,
.shangs .el-table__body-wrapper table {
    width: 100% !important;
}

.shangs .el-table__body,
.shangs .el-table__footer,
.shangs .el-table__header {
    table-layout: auto;
}

.shangs .addproduct {
    position: static;
    margin-left: 10px;
}

.shangs .addproducts {
    position: fixed;
    top: 14vh;
    right: 15vw;
}

.shangs .fenss {
    position: fixed;
    top: 13vh;
    z-index: 1;
}

.fenss .el-input {
    width: 15vw;
}

.fenss .switchs {
    left: 30vw;
}

.shangs .dishesfoots .demo-pagination-blocks {
    position: fixed;
    width: 100vw;
    top: 94vh;
    height: 10vh;
    left: 30vw;
}

/* 新增弹窗样式 */
.shangs .el-dialog__body {
    padding: 10px;
    /* 减少弹窗内的上下左右间距 */
}

.shangs .el-form-item__label {
    width: 80px;
    /* 设置表单项名称的固定宽度，使它们长度一致 */
    text-align: right;
    padding-right: 10px;
}

.shangs.el-form-item {
    margin-bottom: 20px !important;
}

.shangs .el-form-item {
    display: flex;
    align-items: center;
}

.shangs .el-form-item__label {
    flex: 0 0 100px;
}

.shangs .el-input {
    flex: 1;
    margin-right: 10px;
}

.shangs.btn-container {
    position: absolute;
    bottom: 10px;
    left: 10px;
    display: flex;
    gap: 10px;
}
</style>